import { Star } from "lucide-react";

const on = "fill-amber-400 text-amber-400";
const off = "text-muted-foreground/40";

export function Stars({ value, size = "h-3.5 w-3.5", testId }) {
  return (
    <span className="inline-flex" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${size} ${i <= Math.round(value) ? on : off}`} />)}
    </span>
  );
}

export function StarInput({ value, onChange, testId }) {
  return (
    <span className="inline-flex gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button type="button" key={i} aria-label={`${i} stars`} data-testid={`${testId}-${i}`} onClick={() => onChange(i)}>
          <Star className={`h-7 w-7 transition-transform duration-150 hover:scale-110 ${i <= value ? on : off}`} />
        </button>
      ))}
    </span>
  );
}

export function RatingLine({ rating, count, testId }) {
  if (!count) return <span className="text-xs rounded-full bg-primary/10 text-primary px-2 py-0.5" data-testid={testId}>New</span>;
  return (
    <span className="inline-flex items-center gap-1 text-xs" data-testid={testId}>
      <Stars value={rating} /><b>{Number(rating).toFixed(1)}</b><span className="text-muted-foreground">({count})</span>
    </span>
  );
}
